import { Environment } from './interface';

export const environment = {
    cache: true,
    production: true,
} as unknown as Environment;

export function initalizeEnvironment(data: unknown): void {
    Object.assign(environment, data);
    environment.employeeSite = (environment.employeeLoginUrl!=="");
}
